// extracted by mini-css-extract-plugin
export default {"authWrapper":"Auth_authWrapper__Yxou2","formWrapper":"Auth_formWrapper__c2ySO","Buttons":"Auth_Buttons__xO7gb","Right":"Auth_Right__4x-S3"};